module.exports = __webpack_public_path__ + "static/cloud-a60ed8acf891591c2674809ba4565e65.svg";